import * as SeparatorPrimitive from '@radix-ui/react-separator'
import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@ui/lib/utils'

const separatorVariants = cva(
  `
  shrink-0 bg-gray-200
  data-[orientation=horizontal]:h-px data-[orientation=horizontal]:my-xxs
  data-[orientation=vertical]:w-px data-[orientation=vertical]:mx-xxs
  `,
  {
    variants: {
      size: {
        xs: 'data-[orientation=horizontal]:w-4 data-[orientation=vertical]:h-4',
        s: 'data-[orientation=horizontal]:w-6 data-[orientation=vertical]:h-6',
        m: 'data-[orientation=horizontal]:w-8 data-[orientation=vertical]:h-8',
        l: 'data-[orientation=horizontal]:w-10 data-[orientation=vertical]:h-10',
      },
    },
    defaultVariants: {
      size: 's',
    },
  },
)

export interface SeparatorProps
  extends React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Separator>,
    VariantProps<typeof separatorVariants> {}

const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Separator>,
  SeparatorProps
>(({ className, size, ...props }, ref) => (
  <SeparatorPrimitive.Separator
    ref={ref}
    className={cn(separatorVariants({ size, className }))}
    {...props}
  />
))
Separator.displayName = SeparatorPrimitive.Separator.displayName

export { Separator, separatorVariants }
